export enum ITBStep {
	AMOUNT = "amount",
	SUMMARY = "summary",
	SUCCESS = "success"
}
